/**
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: valeriaplutino
 * Created: 3/12/21
 */

import * as React from 'react';
import { Divider, Flex, Heading, Image, Text, useMediaQuery } from '@chakra-ui/react';
import { ProfileMenu } from '../ProfileMenu/ProfileMenu';
import { useAuth } from '../auth/useAuth';
import { useAssignment } from '@/components/contexts/AssignmentContext/useAssignment';
import logo from '@/assets/images/UTS_logo_white.svg';
import { Link } from 'react-router-dom';
import { formatFaculty, formatName } from '@/wpt-lib/utils/formatName';

export const TopNavigation = () => {
    const { authState } = useAuth();
    const { currentAssignment } = useAssignment();

    const [isNarrowViewport] = useMediaQuery('(max-width: 1100px)');
    return (
        <Flex
            height={'80px'}
            bg="black"
            alignItems={'center'}
            justifyContent={'space-between'}
            direction={'row'}
            p={4}
            role="banner"
        >
            <Flex alignItems={'center'} as={Link} to="/">
                <Image src={logo} alt={'UTS logo'} height={12} marginStart={5} />
                {!isNarrowViewport && (
                    <Heading as="h1" size={'md'} color={'white'} marginStart={'30px'} marginEnd={'20px'}>
                        Work Planning Tool
                    </Heading>
                )}
            </Flex>
            <Flex alignItems={'center'} direction={'row'}>
                {authState.isAuthenticated && (
                    <>
                        {!isNarrowViewport && currentAssignment && (
                            <Text
                                fontWeight="bold"
                                color="white"
                                marginRight={3}
                                whiteSpace="nowrap"
                                textOverflow="ellipsis"
                                overflow="hidden"
                            >
                                {formatFaculty(currentAssignment.organisation?.faculty)} -{' '}
                                {currentAssignment.organisation?.name}{' '}
                            </Text>
                        )}
                        <Divider bg="offWhite" orientation="vertical" w={'2px'} marginRight={3} />
                        <ProfileMenu name={formatName(authState.claims?.user)} />
                    </>
                )}
            </Flex>
        </Flex>
    );
};
